import styled from "@emotion/styled";
import type { FC } from "react";
import React from "react";
import { Link } from "react-router-dom";

import { APP_DOWNLOAD_QR_URL } from "src/constants/misc";
import Path from "src/constants/path";
import translate from "src/lib/translate";
import Qrcode from "src/ui/components/Qrcode/Qrcode";
import Translate from "src/ui/components/Translate/Translate";

const QR_CODE_SIZE = 216;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: var(--space-md) 0;

  @media screen and (min-width: 960px) {
    padding-left: 7rem;
  }
`;

const Eyebrow = styled.p`
  margin: 0 0 var(--space-xs);
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--color-charcoal-60);
`;

const Headline = styled.h1`
  margin: 0 0 var(--space-sm);
`;

const Subtitle = styled.p`
  margin: 0 0 var(--space-md);
  color: var(--color-charcoal-80);
`;

const QrHelper = styled.p`
  max-width: ${QR_CODE_SIZE}px;
  margin: var(--space-sm) 0 var(--space-xxs);
`;

const BrowserLink = styled(Link)`
  color: var(--color-sunrise-blue, #80aeff) !important;
`;

const Footnote = styled.p`
  margin: var(--space-sm) 0 0;
  color: var(--color-charcoal-60);
`;

const AppDownloadHeroContent: FC = () => (
  <Wrapper>
    <Eyebrow className="as-eyebrow">
      <Translate msg="downloadApp.eyebrow" />
    </Eyebrow>
    <Headline className="as-h3">
      <Translate msg="downloadApp.title" />
    </Headline>
    <Subtitle className="as-body">
      <Translate msg="downloadApp.subtitle" />
    </Subtitle>
    <Qrcode
      frame
      size={QR_CODE_SIZE}
      text={APP_DOWNLOAD_QR_URL}
      label={translate("downloadApp.title")}
    />
    <QrHelper className="as-body strong">
      <Translate msg="downloadApp.qrHelper" />
    </QrHelper>
    <BrowserLink to={`/${Path.app}`} className="as-body strong">
      <Translate msg="downloadApp.continueInBrowser" />
    </BrowserLink>
    <Footnote className="as-little">
      <Translate msg="downloadApp.footnote" />
    </Footnote>
  </Wrapper>
);

export default AppDownloadHeroContent;
